import request from '@/utils/request';


/*
let server = {
  newsClassificationList: '/article_cats?article_cat_id=1', // 极草咨询新闻分类列表
  dongClassificationList: '/article_cats?article_cat_id=2', // 冬虫夏草新闻分类列表
  shopClassificationList: '/article_cats?article_cat_id=3', // 购物指南
  agreement: '/article_cats?article_cat_id=4', // 协议
  allLists: '/article_cats', // 所有列表
  journalism: '/article_cat', // 新闻列表
  journalismDetails: '/articles', // 新闻列表详情


  payDetails: '/article_cats?include=article', // 购物指南列表详情
};


//极草咨询新闻分类列表
export function newsClassificationList() {
  return request({
    url: server.newsClassificationList ,
    method: 'get',
  })
}


//冬虫夏草新闻分类列表
export function dongClassificationList() {
  return request({
    url: server.dongClassificationList ,
    method: 'get',
  })
}


//购物指南分类列表
export function shopClassificationList() {
  return request({
    url: server.shopClassificationList ,
    method: 'get',
  })
}


//所有列表
export function allLists() {
  return request({
    url: server.allLists ,
    method: 'get',
  })
}


//新闻列表
export function journalism(params , page) {
  return request({
    url: server.journalism +　'/' + params.article +　'/articles?page=' +　page,
    method: 'get'
  })
}


//新闻列表详情
export function journalismDetails(params) {
  return request({
    url: server.journalismDetails +　'/' + params.article +　'/details',
    method: 'get',
    params
  })
}



//购物指南列表详情
export function payDetails(params) {
  return request({
    url: server.payDetails ,
    method: 'get',
    params
  })
}
*/

let server = {
  article_cats:'/article_cats', // 文章分类列表
  articlesList:'/articles', // 文章列表
}



// 文章分类列表
export function articleCats(params) {
  return request({
    url: server.article_cats ,
    method: 'get',
    params
  })
}

// 文章列表
export function articlesList(params,page) {
  return request({
    url: server.articlesList + '?page=' +　page,
    method: 'get',
    params
  })
}

// 文章列表详情
export function articlesDetails(article) {
  return request({
    url: server.articlesList + '/' + article,
    method: 'get',
  })
}










// WEBPACK FOOTER //
// ./src/api/article.js